import clsx from 'clsx'
import classes from './IntegrationsGrid.module.scss'

export const IntegrationsGridSkeleton = () => {
  const result = Array.from({ length: 10 }, (_, i) => (
    <li key={i} className={clsx(classes.item, classes.item__skeleton)}>
      <div className={classes.content}>
        <div className={classes.icon} />
        <div className={classes.links} />
      </div>
    </li>
  ))

  return <ul className={classes.list}>{result}</ul>
}
